
const CommonModalPopUp = (props) => {
  let {
    title,
    children,
    onClose,
    size = "lg",
    keyboard = true,
    backdrop = "static",
    noHeader,
    zIndex = "99999999",
    hideCrosIcon,
    isOpen = true
  } = props;

   if (!isOpen) return null;

  return (
    <>
      <div
        className="!bg-[#0000005c] w-full h-full fixed top-0 left-0 z-50 !rounded-none flex items-center justify-center"
        id="frontm"
        // isopen={true}
        // toggle={onClose}
        // size={size}
        // keyboard={keyboard}
        // backdrop={backdrop}
        // centered={true}
        // zIndex={zIndex}
      >
        <div className="bg-white max-w-[700px] w-full h-fit max-h-[80vh] overflow-auto rounded-20 relative">
          {!hideCrosIcon &&<div onClick={onClose} className="absolute top-[10px] right-[10px] cursor-pointer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-6"
            >
              <path
                fillRule="evenodd"
                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
                clipRule="evenodd"
              />
            </svg>
          </div>}
          {!noHeader && <div className="modal-header">{title}</div>}
          <div className="modal-body">
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default CommonModalPopUp;